<template>
    <header class="--bgSolid --withBorder d-flex justify-content-between align-items-center">

        <!-- Logo -->
        <img class="img-fluid header__logo" src="assets/img/adoptuj-kravicku-logo.svg" alt="adoptuj-kravicku-logo">

        <div class="header__right d-flex">

            <!-- Login -->
            <div v-if="$route.name == 'login'" class="o-registerInfo d-md-flex align-items-center d-none">
                <div class="m-registerInfo__description d-none d-lg-block">
                    <p class="mb-0">Ešte nemáte vytvorené konto?</p>
                </div>
                <div class="m-registerInfo__btn ml-3">
                    <router-link :to="{ name: 'register' }" class="btn --primary">
                        Registrovať sa
                    </router-link>
                </div>
            </div>

            <!-- Register -->
            <div v-if="$route.name == 'register'" class="o-registerInfo d-md-flex align-items-center d-none">
                <div class="m-registerInfo__btn ml-3">
                    <a href="https://adoptujkravicku.sk/pravidla-pouzivania/" class="btn --primary" target="_blank">Pravidlá hry</a>
                </div>
            </div>

            <!-- Orange button -->
            <button :class="'hamburger hamburger--elastic' + isActive" type="button"  @click="sidemenu()">
            <span class="hamburger-box">
                <span class="hamburger-inner"></span>
            </span>
            </button>
            <!-- Sidemenu -->
            <menu-side
                :isActive="isActive"
            />

        </div>

    </header>
</template>



<script>
    import MenuSide from './MenuSide.vue'
    export default {
        components: {
            MenuSide
        },
        props: [
        ],
        mounted() {
            this.toggleBodyClass('addClass', 'profile')
        },
        data() {
            return {
                isActive: ''
            }
        },
        destroyed() {
            this.toggleBodyClass('removeClass', 'profile')
        },
        methods: {
            // mounted + destroy
            toggleBodyClass(addRemoveClass, className) {
                const el = document.body
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className)
                } else {
                    el.classList.remove(className)
                }
            },

            sidemenu() {
                this.isActive == ' is-active' ?  this.isActive = '' : this.isActive = ' is-active'
                if (this.isActive == ' is-active') {
                    this.toggleBodyClass('removeClass', 'menu-open')
                } else {
                    this.toggleBodyClass('addClass', 'menu-open')
                }
            }
        }
    }
</script>